import styles from "./MesaParaPedido.module.css";
import { useNavigate } from "react-router-dom";
import FooterOpcoes from "../../cliente/components/FooterOpcoes";
import { useEffect, useState } from "react";
import ModalCobrarConta from "../../../shared/components/ModalCobrarConta";
import ModalHistoricoMesa from "../../../shared/components/ModalHistoricoMesa";
import HeaderPageEquipe from "../components/HeaderPageEquipe";
import { FiGrid, FiArrowRight, FiDollarSign, FiClock } from "react-icons/fi";

function MesaParaPedido() {
    const [mesas, setMesas] = useState([]);
    const [mesaParaCobrar, setMesaParaCobrar] = useState(null);
    const [mesaParaHistorico, setMesaParaHistorico] = useState(null);
    const navigate = useNavigate();
    const nomeEstabelecimento = localStorage.getItem("nomeEstabelecimento");

    const fetchMesas = async () => {
        try {
            const API_URL = process.env.REACT_APP_API_URL;
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_URL}/mesas`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.ok) {
                const data = await response.json();
                setMesas(data);
            } else {
                console.log("Erro do servidor");
            }
        } catch (error) {
            console.log("Erro ao buscar as mesas do banco de dados: ", error.message);
        }
    };

    useEffect(() => {
        fetchMesas();
    }, []);


    const salvarMesaNoLocalStorage = (id) => {
        localStorage.setItem('id_mesa', id);
        navigate("/novopedido")
    };

    const totalOcupadas = mesas.filter(m => m.conta_aberta).length;

    return (
        <div className={styles.pagina}>
            <HeaderPageEquipe
                nomeEstabelecimento={nomeEstabelecimento}
                nomePage="Mapa de Mesas"
            />

            <div className={styles.resumoFaixa}>
                <div className={styles.resumoItem}>
                    <span className={styles.resumoValor}>{mesas.length}</span>
                    <span className={styles.resumoLabel}>mesas</span>
                </div>
                <div className={styles.resumoDivisor} />
                <div className={styles.resumoItem}>
                    <span className={`${styles.resumoValor} ${styles.resumoValorAlerta}`}>{totalOcupadas}</span>
                    <span className={styles.resumoLabel}>conta aberta</span>
                </div>
                <div className={styles.resumoDivisor} />
                <div className={styles.resumoItem}>
                    <span className={styles.resumoValor}>{mesas.length - totalOcupadas}</span>
                    <span className={styles.resumoLabel}>livres</span>
                </div>
            </div>

            <section className={styles.gradeMesas}>
                {mesas.length > 0 ? (
                    mesas.map((mesa) => (
                        <article
                            key={mesa.id_mesa}
                            className={`${styles.cardMesa} ${mesa.conta_aberta ? styles.cardMesaOcupada : ''}`}
                        >
                            <div className={styles.cardMesaTopo}>
                                <span className={styles.cardMesaNumero}>
                                    {String(mesa.numero_da_mesa || mesa.id_mesa).padStart(2, '0')}
                                </span>
                                <span className={`${styles.statusPill} ${mesa.conta_aberta ? styles.statusOcupada : styles.statusLivre}`}>
                                    <span className={styles.statusDot} />
                                    {mesa.conta_aberta ? 'Conta aberta' : 'Livre'}
                                </span>
                            </div>

                            <div className={styles.cardMesaAcoes}>
                                {mesa.ativa !== false && (
                                    <button
                                        className={styles.btnNovoPedido}
                                        onClick={() => salvarMesaNoLocalStorage(mesa.id_mesa)}
                                    >
                                        Novo pedido
                                        <FiArrowRight size={15} />
                                    </button>
                                )}

                                {mesa.conta_aberta && (
                                    <button
                                        className={styles.btnCobrar}
                                        onClick={() => setMesaParaCobrar(mesa)}
                                    >
                                        <FiDollarSign size={15} />
                                        Cobrar mesa
                                    </button>
                                )}

                                <button
                                    className={styles.btnHistorico}
                                    onClick={() => setMesaParaHistorico(mesa)}
                                >
                                    <FiClock size={15} />
                                    Histórico
                                </button>
                            </div>
                        </article>
                    ))
                ) : (
                    <div className={styles.vazio}>
                        <FiGrid size={36} className={styles.vazioIcone} />
                        <p>Nenhuma mesa cadastrada para este estabelecimento.</p>
                    </div>
                )}
            </section>

            <FooterOpcoes typeView="equipe" />

            {mesaParaCobrar && (
                <ModalCobrarConta
                    idMesa={mesaParaCobrar.id_mesa}
                    paymentOrigin="GARCOM"
                    onClose={() => setMesaParaCobrar(null)}
                    onSuccess={() => {
                        setMesaParaCobrar(null);
                        fetchMesas();
                    }}
                />
            )}

            {mesaParaHistorico && (
                <ModalHistoricoMesa
                    mesa={mesaParaHistorico}
                    onClose={() => setMesaParaHistorico(null)}
                />
            )}
        </div>
    );
}

export default MesaParaPedido;
